import { render, staticRenderFns } from "./funesPresImportF.vue?vue&type=template&id=4bb3828c"
import script from "./funesPresImportF.vue?vue&type=script&lang=js"
export * from "./funesPresImportF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports